export interface Transaction {
    id: number;
    timestamp: string;
    transactionType: string;
    orderId?: string;
    orderDetails?: string;
    description: string;
    amount: number;
    previousCredits: number;
    newCredits: number;
    userId: number;
  }
  
  export interface CreditAdjustment {
    userId: number;
    amount: number;
    type: number;
    description: string;
  }

  export enum TransactionType {
    Credit = 1,
    Debit = 2,
    Reversal = 3,
    Earning = 4,
    Order = 5,
    Penalty = 6,
    Fee = 7,
    Promo = 8,
  }
  
  export const TRANSACTION_TYPE_LABELS: Record<number, string> = {
    [TransactionType.Credit]: 'Credit',
    [TransactionType.Debit]: 'Debit',
    [TransactionType.Reversal]: 'Reversal',
    [TransactionType.Earning]: 'Earning',
    [TransactionType.Order]: 'Order',
    [TransactionType.Penalty]: 'Penalty',
    [TransactionType.Fee]: 'Fee',
    [TransactionType.Promo]: 'Promo',
  };
  
  export const TRANSACTION_TYPE_COLORS: Record<number, string> = {
    [TransactionType.Credit]: '#4caf50',     
    [TransactionType.Debit]: '#f44336',      
    [TransactionType.Reversal]: '#ff9800',  
    [TransactionType.Earning]: '#2196f3',   
    [TransactionType.Order]: '#9c27b0',     
    [TransactionType.Penalty]: '#f44336',   
    [TransactionType.Fee]: '#795548',       
    [TransactionType.Promo]: '#4caf50',     
  };